<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11nDi9m/tc-custom/9780226470986.jpg?1731007752350" alt="This image is the cover for the book More than Cool Reason"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">More than Cool Reason
      </h1>
      <p class="bookDescription body article font2">
        <p>"The authors restore metaphor to our lives by showing us that it's never gone away. We've merely been taught to talk as if it had: as though weather maps were more 'real' than the breath of autumn; as though, for that matter, Reason was really 'cool.' What we're saying whenever we say is a theme this book illumines for anyone attentive." — Hugh Kenner, Johns Hopkins University<br/><br/> "In this bold and powerful book, Lakoff and Turner continue their use of metaphor to show how our minds get hold of the world. They have achieved nothing less than a postmodern Understanding Poetry, a new way of reading and teaching that makes poetry again important." — Norman Holland, University of Florida</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Lakoff, Marl Turner
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Of Chicago Press, Chicago
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d3006c6